module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "communicate-recorders"
  }, [_c('div', {
    staticClass: "communicate"
  }, [(_vm.itemData.length) ? _c('div', {
    staticClass: "selecte-top"
  }, [_c('el-form', {
    ref: "ruleForm",
    staticClass: "menu",
    attrs: {
      "rules": _vm.rules,
      "model": _vm.form,
      "label-width": "90px"
    }
  }, _vm._l((_vm.itemData), function(item, index) {
    return _c('el-form-item', {
      key: item.attr,
      staticClass: "opt-item",
      class: item.attr === 'contactArray' ? 'contactArray' : '',
      attrs: {
        "label": item.attrName,
        "prop": item.attr
      }
    }, [(item.attrVisible) ? _c('el-input', {
      attrs: {
        "value": "* * * * * *",
        "disabled": true
      }
    }) : (item.fieldType === 1 || item.fieldType === 7) ? _c('el-input', {
      attrs: {
        "disabled": item.nonEditable === 1,
        "placeholder": item.placeholder
      },
      model: {
        value: (_vm.form[item.attr]),
        callback: function($$v) {
          _vm.$set(_vm.form, item.attr, $$v)
        },
        expression: "form[item.attr]"
      }
    }) : (item.fieldType === 2) ? _c('el-input', {
      attrs: {
        "disabled": item.nonEditable === 1,
        "placeholder": item.placeholder
      },
      nativeOn: {
        "keyup": function($event) {
          _vm.onInput(item)
        }
      },
      model: {
        value: (_vm.form[item.attr]),
        callback: function($$v) {
          _vm.$set(_vm.form, item.attr, _vm._n($$v))
        },
        expression: "form[item.attr]"
      }
    }, [(item.unit) ? _c('template', {
      slot: "append"
    }, [_vm._v(_vm._s(item.unit) + "\n                    ")]) : _vm._e()], 2) : (item.fieldType === 3 && item.valueArrMap) ? _c('el-select', {
      attrs: {
        "clearable": "",
        "disabled": item.nonEditable === 1,
        "filterable": "",
        "placeholder": item.placeholder
      },
      model: {
        value: (_vm.form[item.attr]),
        callback: function($$v) {
          _vm.$set(_vm.form, item.attr, $$v)
        },
        expression: "form[item.attr]"
      }
    }, _vm._l((item.valueArrMap), function(arr) {
      return _c('el-option', {
        key: arr.key,
        attrs: {
          "label": arr.value,
          "value": arr.key
        }
      })
    })) : (item.fieldType === 3 && item.initValue) ? _c('el-select', {
      attrs: {
        "clearable": "",
        "disabled": item.nonEditable === 1,
        "placeholder": item.placeholder,
        "filterable": ""
      },
      model: {
        value: (_vm.form[item.attr]),
        callback: function($$v) {
          _vm.$set(_vm.form, item.attr, $$v)
        },
        expression: "form[item.attr]"
      }
    }, _vm._l((_vm.strToArrItem(item.initValue)), function(option, index) {
      return _c('el-option', {
        key: index,
        attrs: {
          "value": option
        }
      })
    })) : (item.fieldType === 4) ? _c('el-date-picker', {
      attrs: {
        "disabled": _vm.fuction(item),
        "editable": false,
        "type": "date",
        "value-format": "yyyy-MM-dd",
        "placeholder": "选择日期"
      },
      model: {
        value: (_vm.form[item.attr]),
        callback: function($$v) {
          _vm.$set(_vm.form, item.attr, $$v)
        },
        expression: "form[item.attr]"
      }
    }) : (item.fieldType === 9) ? _c('el-checkbox-group', {
      attrs: {
        "disabled": item.nonEditable === 1
      },
      model: {
        value: (_vm.form[item.attr]),
        callback: function($$v) {
          _vm.$set(_vm.form, item.attr, $$v)
        },
        expression: "form[item.attr]"
      }
    }, _vm._l((_vm.strToArrItem(item.initValue)), function(option, index) {
      return _c('el-checkbox', {
        key: index,
        attrs: {
          "label": option,
          "name": item.attr
        }
      })
    })) : (item.attr === 'contactArray') ? [_c('associated-field', {
      ref: "associatedField",
      refInFor: true,
      attrs: {
        "module": "contactApi",
        "multiselect": true,
        "item": item,
        "form": _vm.form,
        "customerId": _vm.customerId
      },
      on: {
        "addNew": _vm.openAddnew,
        "emitObj": _vm.saveObj
      }
    })] : (item.attr === 'communicateBusiness') ? [_c('communicateBusiness', {
      attrs: {
        "customerId": _vm.customerId,
        "item": item,
        "form": _vm.form
      }
    })] : (item.attr === 'communicateTime') ? [_c('el-date-picker', {
      class: {
        disable: item && item.nonEditable
      },
      attrs: {
        "editable": false,
        "type": "datetime",
        "format": "yyyy-MM-dd HH:mm",
        "value-format": "yyyy-MM-dd HH:mm",
        "picker-options": _vm.disableBefore,
        "placeholder": "选择日期时间"
      },
      model: {
        value: (_vm.form[item.attr]),
        callback: function($$v) {
          _vm.$set(_vm.form, item.attr, $$v)
        },
        expression: "form[item.attr]"
      }
    })] : _vm._e()], 2)
  }))], 1) : _vm._e(), _vm._v(" "), _c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.textareaValue),
      expression: "textareaValue"
    }],
    staticClass: "enter",
    attrs: {
      "placeholder": "输入跟进记录..."
    },
    domProps: {
      "value": (_vm.textareaValue)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.textareaValue = $event.target.value
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "options"
  }, [_c('ul', {
    staticClass: "menu"
  }, [_vm._l((_vm.bottomResult), function(bottom, index) {
    return [(bottom.fieldType === 5) ? _c('li', {
      key: bottom.fieldType,
      staticClass: "opt-item"
    }, [_c('el-badge', {
      staticClass: "item",
      attrs: {
        "hidden": _vm.images.length === 0,
        "value": _vm.images.length
      }
    }, [_c('el-popover', {
      attrs: {
        "placement": "bottom-start",
        "title": "上传图片",
        "width": "400",
        "trigger": "click"
      }
    }, [_c('el-upload', {
      ref: "imgUpload",
      refInFor: true,
      staticClass: "img-box",
      attrs: {
        "action": _vm.uploadUlr,
        "data": _vm.uploadData,
        "list-type": "picture-card",
        "accept": _vm.imgAccept,
        "on-remove": _vm.imgRemove,
        "on-error": _vm.handleError,
        "on-success": _vm.imgAdd,
        "file-list": _vm.uploadImg,
        "before-upload": _vm.handleBeforeUpload
      }
    }, [_c('i', {
      staticClass: "el-icon-plus",
      on: {
        "click": _vm.set_upload_param
      }
    })]), _vm._v(" "), _c('i', {
      staticClass: "text web-icon-img",
      attrs: {
        "slot": "reference"
      },
      slot: "reference"
    })], 1)], 1)], 1) : (bottom.fieldType === 8) ? _c('li', {
      key: bottom.fieldType,
      staticClass: "opt-item"
    }, [_c('el-badge', {
      staticClass: "item",
      attrs: {
        "hidden": _vm.fileAttrValue.length === 0,
        "value": _vm.fileAttrValue.length
      }
    }, [_c('el-popover', {
      attrs: {
        "placement": "bottom-start",
        "title": "上传附件",
        "width": "400",
        "trigger": "click"
      }
    }, [_c('el-upload', {
      ref: "fileUpload",
      refInFor: true,
      attrs: {
        "action": _vm.uploadUlr,
        "data": _vm.uploadData,
        "on-remove": _vm.fileRemove,
        "on-success": _vm.fileAdd,
        "on-error": _vm.handleError,
        "before-upload": _vm.handleBeforeUpload,
        "file-list": _vm.uploadFile
      }
    }, [_c('el-button', {
      staticClass: "text",
      attrs: {
        "size": "small",
        "type": "primary"
      },
      on: {
        "click": _vm.set_upload_param
      }
    }, [_vm._v("添加附件")])], 1), _vm._v(" "), _c('i', {
      staticClass: "text web-icon-file",
      attrs: {
        "slot": "reference"
      },
      slot: "reference"
    })], 1)], 1)], 1) : _vm._e()]
  })], 2), _vm._v(" "), _c('el-button', {
    attrs: {
      "size": "small",
      "type": "primary",
      "disabled": _vm.disSubmit
    },
    on: {
      "click": _vm.handleSubmit
    }
  }, [_vm._v("提 交")])], 1)]), _vm._v(" "), _vm._l((_vm.refVisit), function(item, index) {
    return _c('div', {
      key: item.opportunityId,
      staticClass: "item"
    }, [_c('div', {
      staticClass: "item-content"
    }, [_c('div', {
      staticClass: "user-infos"
    }, [_c('div', [_c('div', {
      staticClass: "title"
    }, [_c('span', {
      staticClass: "name"
    }, [_vm._v(_vm._s(item.userName))]), _vm._v(" "), _c('span', {
      staticClass: "tag"
    }, [_vm._v(_vm._s(item.commuicateTime))])]), _vm._v(" "), _c('div', {
      staticClass: "avatar"
    }, [_c('img', {
      attrs: {
        "width": "44",
        "height": "44",
        "src": item.avatar,
        "alt": item.userName
      }
    })]), _vm._v(" "), _c('div', {
      staticClass: "others"
    }, [_c('span', {
      staticClass: "text"
    }, [_vm._v(_vm._s(item.type))]), _vm._v(" "), _c('span', {
      staticClass: "text"
    }, [(item.hideSupplier) ? _c('a', {
      attrs: {
        "href": "javascript:;"
      },
      on: {
        "click": _vm.unOpen
      }
    }, [_vm._v(_vm._s(item.customerName))]) : _c('a', {
      attrs: {
        "href": "javascript:;"
      },
      on: {
        "click": function($event) {
          _vm.openDetail(item.customerId, _vm.openApi)
        }
      }
    }, [_vm._v(_vm._s(item.customerName))])])])]), _vm._v(" "), _c('div', {
      staticClass: "options"
    }, [(item.isEdit) ? _c('span', {
      staticClass: "text",
      on: {
        "click": function($event) {
          _vm.editItem(item.id)
        }
      }
    }, [_vm._v("编辑")]) : _vm._e()])]), _vm._v(" "), _c('div', {
      staticClass: "article"
    }, [(item.opportunityName) ? _c('a', {
      staticClass: "talk",
      attrs: {
        "href": "javascript:;"
      },
      on: {
        "click": function($event) {
          _vm.openDetail(item.opportunityId, 'opportunityApi')
        }
      }
    }, [_vm._v("#" + _vm._s(item.opportunityName) + "#")]) : _vm._e(), _vm._v(" "), _vm._l((_vm.paragraph(item.memo)), function(p, i) {
      return _c('p', {
        key: i,
        staticClass: "text"
      }, [_vm._v(_vm._s(p))])
    })], 2), _vm._v(" "), (item.images && item.images.length > 2) ? _c('div', {
      staticClass: "gallery"
    }, [_c('ul', {
      staticClass: "gallery-wrap"
    }, _vm._l((_vm.strToArr(item.images)), function(img) {
      return _c('li', {
        key: img,
        staticClass: "img"
      }, [_c('img', {
        attrs: {
          "width": "80",
          "height": "80",
          "src": img
        },
        on: {
          "click": function($event) {
            _vm.openLightbox(img)
          }
        }
      })])
    }))]) : _vm._e(), _vm._v(" "), _c('div', {
      staticClass: "default"
    }, [(item.contactArray.length) ? _c('p', [_vm._v("联系人：\n                "), (['supplier', 'purchase'].indexOf(_vm.moduleName) > -1) ? _vm._l((item.contactArray), function(contact, index) {
      return _c('span', {
        key: contact.contactId
      }, [_vm._v(_vm._s(contact.contactName) + _vm._s(contact.position ? '(' + contact.position + ')' : '') + _vm._s(index !== item.contactArray.length - 1 ? '、' : ''))])
    }) : _vm._l((item.contactArray), function(contact, index) {
      return _c('a', {
        key: contact.contactId,
        on: {
          "click": function($event) {
            _vm.openDetail(contact.contactId, 'contactApi')
          }
        }
      }, [_vm._v(_vm._s(contact.contactName) + _vm._s(contact.position ? '(' + contact.position + ')' : '') + _vm._s(index !== item.contactArray.length - 1 ? '、' : ''))])
    })], 2) : _vm._e(), _vm._v(" "), (item.communicateBusiness.id) ? _c('p', [_vm._v(_vm._s(item.communicateBusiness.type === 'salesOpportunity' ? '跟进机会' : '跟进合同') + "："), _c('a', {
      on: {
        "click": function($event) {
          _vm.openDetail(item.communicateBusiness.id, item.communicateBusiness.type === 'salesOpportunity' ? 'opportunityApi' : 'contractApi')
        }
      }
    }, [_vm._v(_vm._s(item.communicateBusiness.value))])]) : _vm._e(), _vm._v(" "), (item.address) ? _c('p', [_vm._v("位置：" + _vm._s(item.address))]) : _vm._e()]), _vm._v(" "), (_vm.currentOpenIndex === index) ? _c('ul', {
      staticClass: "default"
    }, _vm._l((item.redundantDetail), function(other) {
      return _c('li', {
        key: other.attrName,
        staticClass: "render"
      }, [_c('span', {
        staticClass: "label"
      }, [_vm._v(_vm._s(other.attrName) + "：")]), _vm._v(" "), ([5, 6].indexOf(other.fieldType) > -1) ? _vm._l((_vm.strToArr(other.value4Show)), function(url, index) {
        return _c('span', {
          key: index,
          staticClass: "img",
          on: {
            "click": function($event) {
              _vm.openLightbox(url)
            }
          }
        }, [_c('img', {
          attrs: {
            "src": url,
            "height": "40",
            "width": "40"
          }
        })])
      }) : (other.fieldType === 8) ? [(item.redundantDetail && item.redundantDetail.length) ? _c('attachment-preview', {
        attrs: {
          "data": _vm.fileData(item.redundantDetail)
        }
      }) : _vm._e()] : (other.fieldType === 7) ? [_c('span', {
        staticClass: "text"
      }, _vm._l((_vm.paragraph(other.value4Show)), function(p, i) {
        return _c('p', {
          key: i
        }, [_vm._v(_vm._s(p))])
      }))] : [_c('span', {
        staticClass: "text"
      }, [_vm._v(_vm._s(other.value4Show))])]], 2)
    })) : _vm._e()]), _vm._v(" "), _c('div', {
      staticClass: "item-options"
    }, [(item.like) ? _c('like', {
      attrs: {
        "refId": item.id
      }
    }) : _vm._e(), _vm._v(" "), (item.redundantDetail && item.redundantDetail.length) ? _c('a', {
      staticClass: "more",
      on: {
        "click": function($event) {
          _vm.redundantToggle(index)
        }
      }
    }, [_vm._v(_vm._s(_vm.currentOpenIndex === index ? '收起' : '更多'))]) : _vm._e(), _vm._v(" "), _c('a', {
      staticClass: "option",
      class: {
        'active': item.like
      },
      attrs: {
        "href": "javascript:;"
      },
      on: {
        "click": function($event) {
          _vm.handleLike(item.id, index)
        },
        "mouseover": function($event) {
          _vm.showLike(item.likeCount, index)
        },
        "mouseout": function($event) {
          _vm.hideLike(item.likeCount, index)
        }
      }
    }, [_c('i', {
      staticClass: "icon",
      class: [item.likeCount ? 'web-icon-thumbs-up' : 'web-icon-thumbs-up-o']
    }), _vm._v(" "), _c('span', {
      staticClass: "text"
    }, [_vm._v("点赞"), _c('em', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (item.likeCount),
        expression: "item.likeCount"
      }],
      staticClass: "num"
    }, [_vm._v("(" + _vm._s(item.likeCount) + ")")])])]), _vm._v(" "), _c('a', {
      staticClass: "option",
      class: {
        'active': item.report
      },
      attrs: {
        "href": "javascript:;"
      },
      on: {
        "click": function($event) {
          _vm.handleReport(index)
        }
      }
    }, [_c('i', {
      staticClass: "icon",
      class: [item.commentCount ? 'web-icon-comment' : 'web-icon-comment-o']
    }), _vm._v(" "), _c('span', {
      staticClass: "text"
    }, [_vm._v("评论"), _c('em', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (item.commentCount),
        expression: "item.commentCount"
      }],
      staticClass: "num"
    }, [_vm._v("(" + _vm._s(item.commentCount) + ")")])])])], 1), _vm._v(" "), (item.report) ? _c('report', {
      attrs: {
        "refId": item.id
      }
    }) : _vm._e()], 1)
  }), _vm._v(" "), _c('div', {
    staticClass: "load-more"
  }, [(_vm.showLoadmore) ? [_c('i', {
    staticClass: "el-icon-loading"
  }), _vm._v("\n            加载更多\n        ")] : _vm._e(), _vm._v(" "), (!_vm.showLoadmore && _vm.page.total > _vm.page.size) ? [_vm._v("没有更多")] : _vm._e()], 2), _vm._v(" "), (_vm.planShow) ? _c('customer-plan', {
    attrs: {
      "listData": _vm.planData
    },
    on: {
      "close": function($event) {
        _vm.planShow = false
      }
    }
  }) : _vm._e(), _vm._v(" "), (_vm.addnewShow) ? _c('add-new', {
    ref: "addNew",
    attrs: {
      "modal": false,
      "addnewProp": _vm.addnewProp
    },
    on: {
      "closeForDetail": function($event) {
        _vm.addnewShow = false
      },
      "refresh": _vm.refreshForm
    }
  }) : _vm._e()], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-5310a153","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/detail/communicate-record-new.vue
// module id = 1271
// module chunks = 82